import { parseUKDate, formatDateUK } from './createConfig.helpers';

export default function buildRowFromForm({
  operator,      
  unit,
  evn,
  meterType,
  meterNumber,
  fromDate,
  comments,
}) {
  return {
    Operator: operator || null,                 
    Unit: unit,
    EVN: evn,
    MeterNumber: (meterNumber || '').trim(),
    MeterType: meterType?.value,
    FromDate: fromDate ? formatDateUK(parseUKDate(fromDate)) : '',
    Comments: (comments || '').trim(),
    Validated: false,
  };
}
